import { render, staticRenderFns } from "./CouponsExpired.vue?vue&type=template&id=1e2000a6&scoped=true&"
import script from "./CouponsExpired.vue?vue&type=script&lang=js&"
export * from "./CouponsExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2000a6",
  null
  
)

export default component.exports